/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { IUser, UsersMeResponse } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';

export class UserEndpoint extends BaseEndpoints<IUser> {
  constructor(client: Client) {
    super(client, 'auth/users');
  }

  me(token: string): Promise<UsersMeResponse> {
    return this.client._get(`${this.resourceEndpoint}/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
}
